module.exports = __webpack_public_path__ + "static/news6pic1-0bdfbd72cc0fbc11e476a52b11f181c1.jpg";